if (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    localStorage.setItem('theme', 'dark');
    document.documentElement.classList.add('dark');
}
if (!localStorage.getItem('theme') && !window.matchMedia('(prefers-color-scheme: dark)').matches) {
    localStorage.setItem('theme', 'light');
    document.documentElement.classList.remove('dark');
}
if (localStorage.getItem('theme') === 'dark') {
    document.documentElement.classList.add('dark');
}
if (localStorage.getItem('theme') === 'light') {
    document.documentElement.classList.remove('dark');
}